export default [{
	titulo: 'Licitações',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/licitacoes',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]